/**
 * Vuex module for sessions (Call Panel v2 switching)
 */
import debug from 'debug'
import API from '@/api'
import events from 'Store/events'

const dbg = debug('store:action:sessions:')

const actions = {
  /**
   * Fetch whether the current user is a Call Panel v2 beta tester.
   * Result is cached unless force is true.
   */
  getBetaTester ({ commit, state }, force = false) {
    if (import.meta.env.NODE_ENV === 'test') {
      return false
    }
    if (state.betaTesterLoaded && !force) {
      return Promise.resolve(state.isBetaTester)
    }
    dbg('Get callpanel v2 beta tester status')
    return API.callpanelV2BetaTester().then(response => {
      const betaTester = Boolean(response.data?.beta_tester)
      commit('SET_BETA_TESTER', betaTester)
      return betaTester
    }).catch(err => {
      dbg(err)
      commit('SET_BETA_TESTER', false)
      return false
    })
  },

  /**
   * Request the Call Panel v2 redirect URI for the current user.
   */
  switchToCallpanelV2 () {
    if (import.meta.env.NODE_ENV === 'test') {
      return Promise.resolve(null)
    }
    dbg('Switch to callpanel v2')
    return API.switchToCallpanelV2().then(response => {
      return response.data?.redirect_uri
    }).catch(err => {
      dbg(err)
      const msg = API.getException(err) ||
        'Failed to switch to Call Panel v2.'
      events.pubError(msg)
      return null
    })
  }
}

const mutations = {
  SET_BETA_TESTER (state, isBetaTester) {
    state.isBetaTester = isBetaTester
    state.betaTesterLoaded = true
  }
}

const state = {
  isBetaTester: false,
  betaTesterLoaded: false
}

const getters = {
  isBetaTester: state => state.isBetaTester,
  betaTesterLoaded: state => state.betaTesterLoaded
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
